import React from "react";
import "./Contato.css";
import Logo from "../../assets/imgs/MARCA_INSIGNE_BRANCA.png";



function Contato() {

  return (
    <div className="contato-container">
      <div className="contato-img-container">
        <img alt="logo" src={Logo}></img>
      </div>
      <div className="contato-content">
        <span>
          <i class="uil uil-at"></i>
          <p>contato@insigneacademica.com.br</p>
        </span>

        <span>
          <i class="uil uil-phone"></i>
          <p>(84) 99229-3892</p>
        </span>
        {/* 
        <span>
          <i class="uil uil-map-marker"></i>
          <p>Tirol Way Office Tower, localizado na rua Afonso Pena, 192, Tirol - Natal/RN, CEP: 59-123-111</p>
        </span> */}

        <a
          href="https://wa.link/o4jzw4"
          target="_blank"
          rel="noreferrer"
          alt="link para mentoria"
          className="main-btn"
        >
          Fale com o editor-chefe
        </a>

      </div>
    </div>
  );
}

export default Contato;
